import script from "./ModalConfirmEditActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalConfirmEditActions.vue?vue&type=script&setup=true&lang=ts"

import "./ModalConfirmEditActions.vue?vue&type=style&index=0&id=b185ef60&lang=scss"

const __exports__ = script;

export default __exports__